import { c as _c } from "react/compiler-runtime";
import '@src/theme/styles/globals.css';
import '@src/theme/styles/fonts';
import { Box, ChakraProvider } from '@chakra-ui/react';
import { useWindow } from '@src/hooks/useWindow.tsx';
import { getDesignSystem } from '@src/theme';
import { ColorModeProvider, type ColorModeProviderProps } from './color-mode';
export function ScoChakraProvider(props) {
  const $ = _c(14);
  const windowProxy = useWindow();
  const defaultDesignSystemKey = windowProxy?.location?.pathname?.startsWith("/admin") ? "admin" : "sco";
  const t0 = props.designSystemKey || defaultDesignSystemKey;
  let t1;
  if ($[0] !== t0) {
    t1 = getDesignSystem(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = props.colorPalette || "purple";
  const t3 = props.colorPalette || "orange";
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = {
      _dark: t2,
      _light: t3
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== props.children || $[6] !== t4) {
    t5 = <Box colorPalette={t4}>{props.children}</Box>;
    $[5] = props.children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t5) {
    t6 = <ChakraProvider value={t1}>{t5}</ChakraProvider>;
    $[8] = t1;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== props || $[12] !== t6) {
    t7 = <ColorModeProvider defaultColorMode="dark" {...props}>{t6}</ColorModeProvider>;
    $[11] = props;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}